import { Box } from '@mui/material'
import { SORView } from './SOR.view'
import { SORSubheading } from './SOR.design'

// Master (tenant-wide) holding-tank tab on the SOR page.
// Reads/writes SchedulerApp/Inputs/TanksDelta/ and .../TankEligibilityDelta/.
// New schedules are seeded from both at creation time (`folders` in
// SchedulerService/models/scheduler_model.py), so a vessel declared here
// reaches every schedule created after it — and only those; see
// docs/SOR_INPUT_TABLE_ALIGNMENT.md §5.2 for the existing-schedule gap.
//
// Two tables on ONE tab, mirroring the per-schedule `ScheduleTanks.view`
// rather than giving each its own sidebar entry. They are two halves of one
// setup step: a vessel with no eligibility row holds nothing and the engine
// ignores it, so splitting them across tabs would let a planner leave the
// second half unwritten without ever seeing it was missing.
//
// Both are plain `SORView`s — no bespoke view is needed here, unlike
// SORSynchronizedLines/SORSterilizerRouting, because neither table is a
// projection and neither needs metadata beyond its own rows. Each keeps its
// own save, upload contract and Add Row button.
//
// `tank-week-state` is deliberately NOT here. A week's opening stock is last
// week's measured output, so one master figure copied into eight weeks would
// assert eight starting stocks from one typed number.
export const SORTanks = () => (
  <Box>
    <SORSubheading title="Tanks" first>
      A tank is filled, held, then drained completely to a line or a second
      kitchen. Accumulate is on by default, so a kitchen run may add to what the
      vessel already holds as long as it is the same product, up to its
      Capacity; untick it and the vessel must be drawn empty and cleaned before
      it takes another batch. Maturity runs from the most recent run into the
      tank; the maximum hold runs from the first.
    </SORSubheading>
    <SORView API="tanks" />

    <SORSubheading title="Tank Eligibility">
      Which product each tank may hold — one row per tank, since a tank is
      dedicated to a single product in this version.
    </SORSubheading>
    <SORView API="tank-eligibility" />
  </Box>
)
